import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { buttonVariants, Logo } from '@/shared/ui';

export function NotFoundPage() {
  const { t } = useTranslation('common');

  return (
    <div className="bg-canvas flex min-h-dvh flex-col items-center justify-center gap-6 px-6 text-center">
      <Logo size="lg" />
      <div>
        <p className="text-brand-text text-xs font-bold tracking-[0.08em] uppercase">Błąd 404</p>
        <h1 className="text-fg-strong mt-2 text-3xl font-extrabold tracking-[-0.03em]">
          {t('errors.notFound')}
        </h1>
      </div>
      <Link to="/" className={buttonVariants({ variant: 'primary', size: 'md' })}>
        Wróć na stronę główną
      </Link>
    </div>
  );
}
